import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcExtensionBrokerRequest, RpcExtensionBrokerRequestKey } from './rpc-extension-broker-model';
import { RpcExtensionBrokerRequestHandler } from './rpc-extension-broker-request-handler';

/**
 * Rpc extension broker subject interface.
 */
export interface RpcExtensionBrokerSubject extends Subject<DeferredData<RpcExtensionBrokerRequest, void>> {}

/**
 * The class to implement Rpc extension with Subject server.
 */
export class RpcExtensionBrokerSubjectServer
        extends RpcSubjectServer<RpcExtensionBrokerRequest, void>
        implements RpcExtensionBrokerRequestHandler {

    /**
     * Initializes a new instance of the RpcExtensionBrokerSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcExtensionBrokerRequestKey.command);
    }

    /**
     * The handler to respond a request for Rpc extension call.
     *
     * @param data The extension object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcExtensionBrokerRequest): Promise<void> {
        return this.processNextForSubject(RpcExtensionBrokerRequestKey.command, data);
    }
}
